import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import ObjectTypesService from 'cio/services/object-types';

export default class ObjectsRoute extends Route {
  @service objectTypes!: ObjectTypesService;

  crumb() {
    let path = this.routeName;
    if (this.objectTypes.hasObjectTypes) {
      path = 'workspace-settings.objects';
    }
    return {
      name: 'Objects',
      path,
      helpQuery: 'objects quick start',
    };
  }
}
